module.exports = __webpack_public_path__ + "files/poster_award.74e1b7d5.pdf";